import { useTranslation } from '../../../shared/i18n';
import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Alert, Button, Card, Spin } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import DnsOneClick from '../../components/DnsOneClick';
import webmailService from '../../services/webmailService';
import { userPath } from '../../../shared/config/paths';

/**
 * /dns/authorize?domain=example.com&app=webmail — kept for old links; the product pages
 * embed the same one-click component directly.
 */
const DnsAuthorize = () => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const domain = (searchParams.get('domain') || '').toLowerCase();
    const app = searchParams.get('app') || 'webmail';
    const [refId, setRefId] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let alive = true;
        (async () => {
            if (!domain || app !== 'webmail') { setError(t('Invalid link')); return; }
            const res = await webmailService.getDomains();
            if (!alive) return;
            const list = Array.isArray(res?.data) ? res.data : [];
            const hit = list.find(d => (d.name || '').toLowerCase() === domain);
            if (hit) setRefId(hit.local_id); else setError(t('Mail domain {{domain}} not found', { domain }));
        })();
        return () => { alive = false; };
    }, [domain, app, t]);

    return (
        <Card
            title={t('One-click DNS · {{domain}}', { domain })}
            extra={<Button icon={<ArrowLeftOutlined />} onClick={() => navigate(userPath('/webmail/domains'))}>{t('Back')}</Button>}
        >
            {error ? <Alert type="warning" showIcon message={error} />
                : refId ? <DnsOneClick app="webmail" id={refId} title={t('Mail records')} />
                    : <div style={{ textAlign: 'center', padding: 32 }}><Spin /></div>}
        </Card>
    );
};

export default DnsAuthorize;
